import { axiosInstance as axios } from '../main';
import { baseApiUrl } from '../environment/values';
import helpers from '../helpers/helpers';
import queryString from 'query-string';

const state = {
    visits: [],
    visitStatus: 'idle',
    typeOptions: [],
    totalVisits: null,
}

const getters = {
    visitSuccess: state => state.visitStatus === 'success',
    visitLoading: state => state.visitStatus === 'loading',
    visitError: state => state.visitStatus === 'error'
}

const actions = {
    async getAllVisits({ commit }, { pagination }) {
        if (!pagination) return
        
        commit('setVisitStatus', 'loading')

        const { page, type, search, itemsPerPage:rowsPerPage } = pagination

        const typeQuery = helpers.generatePaginationQuery('visit_type', type)

        const queryParams = {
            ...helpers.createQueryParam('page', page),
            ...helpers.createQueryParam('search', search),
            ...helpers.createQueryParam('page_size', rowsPerPage),
        }

        if (typeQuery) {
            Object.assign(queryParams, queryString.parse(typeQuery))
        }

        const query = queryString.stringify(queryParams)
        const url = `${baseApiUrl}technician_visit/?${query}`
        
        
        try {
            const { data } =  await axios.get(url)
            commit('setVisits', data.results)
            commit('setTotalVisits', data.count)
            commit('setTypeOptions', data.filters)
            commit('setVisitStatus', 'success')
        } catch (error) {
            console.error({ error })
        } finally {
            commit('setVisitStatus', 'idle')
        }
    }
}

const mutations = {
    setVisits(state, visits) {
        state.visits = visits
    },
    setVisitStatus(state, status) {
        state.visitStatus = status
    },
    setTotalVisits(state, totalVisits) {
        state.totalVisits = totalVisits
    },
    setTypeOptions(state, typeOptions) {
        state.typeOptions = typeOptions
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}